import * as z from "zod";

export const PRODUCT_IDS = [
  "returns",
  "order-editing",
  "shipping-fulfillment",
  "chargebacks",
  "withdrawals",
  "contextual",
  "recover",
  "email-sms",
  "aeo",
  "checkout-optimization",
  "ai-sales-support",
  "inventory-management",
  "agentic-catalog",
] as const;

export type ProductId = (typeof PRODUCT_IDS)[number];

export const ONBOARDING_V2_STATUSES = [
  "partial-completion",
  "completed",
  "help-requested",
] as const;

export type OnboardingV2Status = (typeof ONBOARDING_V2_STATUSES)[number];

export const initialize = {
  name: "initialize" as const,
  input: z.object({}),
  output: z.object({
    merchantInfo: z.object({
      merchantId: z.string(),
      storeName: z.string(),
      storeUrl: z.string(),
      email: z.string(),
      logoUrl: z.string().optional(),
      domain: z.string().optional(),
      myshopifyDomain: z.string().optional(),
      shopifyAdminUrl: z.string().optional(),
      shopifyAppEmbedEditorUrl: z.string().optional(),
      shopifyCheckoutEditorUrl: z.string().optional(),
      appEmbedEnabled: z.boolean(),
    }),
    enabledProducts: z.record(z.enum(PRODUCT_IDS), z.boolean()),
    returnsSelfOnboardingBlocked: z.boolean(),
    featureFlags: z.object({
      /** When false, OMS onboarding shows the Calendly schedule-call card instead of the self-serve flow. */
      omsOnboarding: z.boolean(),
      /** When false, Chargebacks onboarding shows the Calendly schedule-call card instead of the self-serve flow. */
      chargebacksOnboarding: z.boolean(),
      /** When false, Contextual onboarding shows the Calendly schedule-call card instead of the self-serve flow. */
      contextualOnboarding: z.boolean(),
      /** When false, Recover onboarding shows the Calendly schedule-call card instead of the self-serve flow. */
      /** When false, the returns coverage-widget step uses the old placement-test flow instead of the embedded coverage builder. */
      coverageBuilder: z.boolean(),
    }),
  }),
};
